import React from 'react';
import { FormBuilder } from 'commons-ui';
import useSchedule from './useSchedule';
import { SCHEDULE_FORM_FIELD_CONFIG, scheduleValidationSchema, SCHEDULE_FORM_LAYOUT_CONFIG } from '../../formConfig';

const scheduleSegment: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useSchedule();
	return (
		<FormBuilder
			data={data}
			mode='create'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			setShowLoader={setShowLoader}
			fieldConfig={SCHEDULE_FORM_FIELD_CONFIG}
			layoutConfig={SCHEDULE_FORM_LAYOUT_CONFIG}
			validationSchema={scheduleValidationSchema}
			buttonLabels={{ discardLabel: 'Back', submitLabel: 'Submit' }}
		/>
	);
};
export default scheduleSegment;
